import { ArrowRight } from '@velocity-exchange/icons';
import { useCallback } from 'react';
import useGoToRoute from 'src/hooks/useGoToRoute';
import { NotificationData } from 'src/utils/notifications';
import Button from 'src/components/primitives/Button/Button';
import TextButton from 'src/components/primitives/TextButton/TextButton';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName, WithChildren {
	alertType: 'major' | 'minor';
	action: NotificationData['action'];
	dismissNotification: () => void;
}

export default function AlertNotificationAction({
	alertType,
	action,
	className,
	children,
	dismissNotification,
}: Props) {
	const goToRoute = useGoToRoute();

	const onClick = useCallback(() => {
		if (!action) {
			return;
		}

		if ('callback' in action) {
			action.callback();
		}

		if ('href' in action) {
			goToRoute(action.href);
		}

		dismissNotification();
	}, [action, dismissNotification, goToRoute]);

	if (alertType === 'major') {
		return (
			<Button
				size="md"
				variant="primary"
				onClick={onClick}
				className={className}
			>
				{children}
			</Button>
		);
	}

	if (!action) {
		return null;
	}

	return (
		<TextButton
			size="sm"
			variant="tertiary"
			onClick={onClick}
			className={className}
			rightIcon={ArrowRight}
		>
			{children}
		</TextButton>
	);
}
